import {HeaderNotificationBox, HeaderText} from "./InvoiceHeaderNotification.styles";
// @ts-ignore
import ErrorIcon from './error_outline.svg?react';


export default function InvoiceHeaderNotification() {

    return (
        <HeaderNotificationBox>
            <ErrorIcon/>
            <HeaderText>Fields need attention</HeaderText>
        </HeaderNotificationBox>
    )
}
